import axios from '../utils/axios';

export default {
    update: () => axios.post('v3/personalisations/popup-shown', {})
};
